import { render, staticRenderFns } from "./_base-loader.vue?vue&type=template&id=bdb82eb8&scoped=true"
import script from "./_base-loader.vue?vue&type=script&lang=js"
export * from "./_base-loader.vue?vue&type=script&lang=js"
import style0 from "./_base-loader.vue?vue&type=style&index=0&id=bdb82eb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb82eb8",
  null
  
)

export default component.exports